import React, { Component } from 'react';

import { Overlay, Progress, Icon } from '@icedesign/base';
import IceContainer from '@icedesign/container';

import { formatMessage } from '@/i18n';
import Colors from '@/tool/Colors';
import EventEmitter, { FINGERPRINT_DOWNLOADING_PROGRESS } from '@/tool/events';

export default class FingerprintDownloader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
    };
  }

  progressListenr = data => {
    const progressInfo = {
      totalFingerprint: data.total,
      currentFingerprint: data.current,

      totalPackets: data.packets,
      currentPacket: data.curpacket,
    };

    const { totalFingerprint, currentFingerprint, totalPackets, currentPacket } = progressInfo;

    const finishedPercent = (100 / totalFingerprint) * (currentFingerprint - 1);
    const currentPercent = ((currentPacket / totalPackets) * 100) / totalFingerprint;
    const progress = (currentPercent + finishedPercent).toFixed(2);

    // console.log('progress', progress);

    if (progress >= 100) {
      setTimeout(() => {
        this.props.onFinish();
        // 防止第二次调用显示的时候是从非0开始的；
        this.setState({
          progress: 0,
        });
      }, 1000);
    }
    this.setState({
      progress,
    });
  };

  componentDidMount() {
    EventEmitter.on(FINGERPRINT_DOWNLOADING_PROGRESS, this.progressListenr);
  }

  componentWillUnmount() {
    EventEmitter.removeListener(FINGERPRINT_DOWNLOADING_PROGRESS, this.progressListenr);
  }

  render() {
    const { visible } = this.props;
    const { progress } = this.state;

    const stateProp =
      progress >= 100
        ? {
            state: 'success',
            suffix: <Icon type="select" size="xl" style={{ color: Colors.success }} />,
          }
        : progress == 0
        ? {
            suffix: (
              <img src={require('./images/fingerprint.gif')} style={{ width: 80, height: 80 }} />
            ),
          }
        : {};
    return (
      <div>
        <Overlay
          visible={visible}
          hasMask
          disableScroll
          align="cc cc"
          // 不设置高度不居中???
          style={styles.overlayContainer}
          // onRequestClose={this.close}
          wrapperClassName="overlayWrapper"
          // shouldUpdatePosition={true} //防止出现个别情况下不居中的问题，不然就需要使内容高度固定，像LockConnector那样;
        >
          <IceContainer
            title={formatMessage('key.takeout.fingerprint.download')}
            style={styles.overlayContent}
          >
            <div>{formatMessage('key.takeout.fingerprint.download.desc')}</div>
            {
              <Progress
                shape="circle"
                percent={Number(progress)}
                {...stateProp}
                style={{ marginTop: 25 }}
              />

              // progress == 0 ?
              //     <img src={require('./images/fingerprint.gif')} style={{ width: 100, height: 100, marginTop: 25 }} />
              //     :
              //     <Progress shape='circle' percent={Number(progress)} {...stateProp} style={{ marginTop: 25 }} />
            }
          </IceContainer>
        </Overlay>
      </div>
    );
  }
}

const styles = {
  overlayContainer: {
    height: 250,
    width: 300,
  },
  overlayContent: {
    textAlign: 'center',
  },
};
